import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-bill-invoice-type',
  templateUrl: './bill-invoice-type.component.html',
  styleUrls: ['./bill-invoice-type.component.scss']
})
export class BillInvoiceTypeComponent implements OnInit,OnDestroy {
  billInvoiceType:any = null
  apisub: Subscription
  constructor(private apiservice: ApiService, @Inject(MAT_DIALOG_DATA) public parentdata:any,private loaderService: LoaderServiceService, private activemodal: MatDialogRef<BillInvoiceTypeComponent>) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_ENTITY_PRIMARY_TAX_DATA){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })
   }

  ngOnInit(): void {
    this.billInvoiceType = this.parentdata.taxData.bill_invoice_type ?? null
    console.log(this.billInvoiceType);
    
    console.log(this.parentdata);
    
  }

  onSave(){
    this.loaderService.showLoader = true
    if(this.parentdata.type == 0){
      let data = {
        "pan_number": this.parentdata.taxData?.pan_number ,
        "tan_number": this.parentdata.taxData?.tan_number,
        "gst_number": this.parentdata.taxData?.gst_number,
        "entity_hash": this.parentdata.entityHash,
        "bill_invoice_type": this.billInvoiceType,
        "tax_collection_status": this.parentdata.taxData?.entity_tax_collection_status ?? 0
      }
      Object.keys(data).forEach(key => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      // this.loaderService.showLoader = true
      // this.loader = true
      this.apiservice.addEditEntityPrimaryTaxData(data)

    }
    else if(this.parentdata.type == 1){
      let data = {
        "entity_hash":this.parentdata.entityHash,
        "tax_collection_status": this.parentdata.taxData?.tax_collection_status ?? 0,
        "tax_types": this.parentdata.taxData?.tax_types ?  this.parentdata.taxData?.tax_types.map((item:any) => {
          return {
            "tax_type": item.taxation_type, 
            "identification_no": item.identification_no
          }
        }) : [],
        "bill_invoice_type": this.billInvoiceType,
      }
      console.log(data);
      
      // this.loaderService.showLoader = true
      // // this.loader = true
      this.apiservice.addEditInternationalEntityTaxConfiguration(data)
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

}
